import React from 'react'
import { BottomSheetProps } from '@yanolja-org/ya-com-bottom-sheet'
import ItemIcon from './ItemIcon'
import BottomSheet from '~/app/components/common/BottomSheet/BottomSheet'

/**
 * BottomSheetWithItemIcon component
 * author: soojin.oh
 */

// type definitions
type BottomSheetWithItemIconImpl = React.FunctionComponent<
  {
    items: { title: string; id: string; icon: string }[]
    onItemSelected: (id: string) => void
  } & BottomSheetProps
>

// BottomSheetWithItemIcon component
const BottomSheetWithItemIcon: BottomSheetWithItemIconImpl = function ({
  isOpened,
  title,
  onRequestClose,
  buttons,
  items,
  onItemSelected,
  onBackgroundClick,
}) {
  return (
    <BottomSheet
      isOpened={isOpened}
      onRequestClose={onRequestClose}
      title={title}
      buttons={buttons}
      onBackgroundClick={onBackgroundClick}
    >
      {items.map(item => (
        <ItemIcon
          key={item.id}
          id={item.id}
          title={item.title}
          icon={item.icon}
          onClick={onItemSelected}
        />
      ))}
    </BottomSheet>
  )
}

export default BottomSheetWithItemIcon
